import React, { useContext } from 'react';

import { TreeStates } from '../../types';

import type { PageTree, PageTreeContextType } from './types';

const noop = () => {};

export const ConfluencePageTreeContext = React.createContext<PageTreeContextType>({
	treeState: TreeStates.Loading,
	spaceKey: null,
	rootContentId: null,
	items: null,
	errorType: null,
	accountId: '',
	setContent: noop,
	expandSubtree: () => Promise.reject(),
	collapseSubtree: noop,
	insertPage: () => Promise.reject(),
	updatePage: () => Promise.reject(),
	removePage: () => Promise.reject(),
	canShowMorePages: false,
	showMorePages: () => Promise.resolve(),
	setProjectData: noop,
});

export const useConfluencePageTreeContext = () =>
	useContext<PageTreeContextType>(ConfluencePageTreeContext);

// a limited export to prevent consumers from accessing internals
export const useConfluencePageTree = (): PageTree => {
	const { treeState, setContent, insertPage, updatePage, removePage, setProjectData } =
		useContext<PageTreeContextType>(ConfluencePageTreeContext);
	return {
		treeState,
		setContent,
		insertPage,
		updatePage,
		removePage,
		setProjectData,
	};
};
